import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AnimateModule, BasicPage, HeaderComponent } from '@pro-connect/shared';

declare const Optanon: any;

@Component({
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AnimateModule, HeaderComponent],
})
export class CookiesPolicyComponent extends BasicPage {
  public override loading = signal(false);

  constructor() {
    super();
  }

  public ngAfterViewInit(): void {
    this.loading.set(true);
    setTimeout(() => {
      if (!Optanon) {
        console.warn('Optanon is not defined');
        this.loading.set(false);
        return;
      }
      this.loading.set(false);
      Optanon?.initializeCookiePolicyHtml();
    }, 1000);
  }
}
